import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessagingService } from '../../../services/messaging.service';
import { FeeScheduleService } from '../services/fee-schedule.service';
import {MatButton} from '@angular/material/button';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {CreateScheduleModel} from '../../../models/fee-schedule/create-schedule.model';

@Component({
    selector: 'app-create-fee-schedule',
    templateUrl: './create-fee-schedule.component.html',
    styleUrls: ['./create-fee-schedule.component.css']
})
export class CreateFeeScheduleComponent implements OnInit {

    @ViewChild('btnCreate') btnCreate: MatButton;

    ENUM_ORGANIZATION_TYPE_INSURANCE: string = '00000044-1000-0000-0000-000000000002';

    organizations: OrganizationDataModel[] = [];
    newScheduleObject: CreateScheduleModel;
    editMode: boolean = false;
    isLoading: boolean = false;
    loadingMessage: string = 'Creating new fee schedule ...';
    isLoadingMessage: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<CreateFeeScheduleComponent>,
        private messagingService: MessagingService,
        private feeScheduleService: FeeScheduleService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
      console.log('in init',this.data);

        if (this.data.schedule && this.data) {
            this.editMode = true;
            this.newScheduleObject = this.data.schedule;
        }
        else {
            this.newScheduleObject = new CreateScheduleModel();
        }

        const currentUser: any = JSON.parse(localStorage.getItem('storedUser'));
        this.newScheduleObject.TDOCID = currentUser.TDOCID;

        this.fetchOrganizationsInuranceCo()
            .then((response: OrganizationDataModel[]) => {
                this.organizations = response;

                // sort by organization name, always showing the default fee organization at the top
                this.organizations = this.organizations.sort((a, b) => {
                    if (a.enumOrganizationTypeId === '00000044-1000-0000-0000-000000000007') { return -2; }
                    if (a.OrganizationName < b.OrganizationName) { return -1; }
                    if (a.OrganizationName > b.OrganizationName) { return 1; }
                    return 0;
                });

                // format default insurance company item
                this.organizations.forEach(item => {
                    if (item.enumOrganizationTypeId === '00000044-1000-0000-0000-000000000007') {
                        item.OrganizationName = 'Default Fees for Practice';
                    }
                });
            }, err => {
                console.log(err);
            });
    }

    fetchOrganizationsInuranceCo() {
        const promise = new Promise((resolve, reject) => {
            this.feeScheduleService.getOrganizationsByType('00000044-1000-0000-0000-000000000002')
                .subscribe(response => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject('no response');
                    }
                }, err => {
                    reject(err);
                });
        });
        return promise;
    }

    editSchedule() {
        const scheduleCopy = JSON.parse(JSON.stringify(this.newScheduleObject));
        scheduleCopy.dataFeeScheduleItems = [];
        scheduleCopy.dataFeeScheduleDoctors = [];

        this.feeScheduleService.editFeeSchedule(scheduleCopy)
            .subscribe(response => {
                if (response) {
                    this.messagingService.sendComponentMessage('DISPLAY_SUCCESS', {
                        message: 'Schedule created'
                    });
                    this.dialogRef.close({
                        feeSchedule: response
                    });
                } else {
                    this.messagingService.sendComponentMessage('DISPLAY_WARNING', {
                        message: 'Whoops.. something went wrong'
                    });
                    this.dialogRef.close(false);
                }

            }, err => {
                this.messagingService.sendComponentMessage('DISPLAY_WARNING', {
                    message: 'Whoops.. something went wrong'
                });
                this.dialogRef.close(false);
            });
    }

    createSchedule() {


        if (this.editMode) {
            this.editSchedule();
            return;
        }

        if(this.newScheduleObject.organizationID == null )  {

          return ;
        }


        this.isLoading = true;
        this.isLoadingMessage = true;
        this.feeScheduleService.createFeeSchedule(this.newScheduleObject)
            .subscribe(response => {
                if (response) {
                    this.isLoading = false;
                    this.isLoadingMessage = false;
                    this.messagingService.sendComponentMessage('DISPLAY_SUCCESS', {
                        message: 'Schedule created'
                    });
                    this.dialogRef.close({
                        feeSchedule: response
                    });
                } else {
                    this.messagingService.sendComponentMessage('DISPLAY_WARNING', {
                        message: 'Whoops.. something went wrong'
                    });
                    this.dialogRef.close({
                        fetch: false
                    });
                }

            }, err => {
                this.isLoading = false;
                this.messagingService.sendComponentMessage('DISPLAY_WARNING', {
                    message: 'Whoops.. something went wrong'
                });
                this.dialogRef.close({
                    fetch: false
                });
            });
    }

    close() {
        this.dialogRef.close({
            fetch: false
        });
    }

    changeDescription(event) {
        this.newScheduleObject.name = event.source.triggerValue;
        this.btnCreate.disabled = false;
    }

    onCancelClick() {
        this.close();
    }

    onOkClick() {
        this.createSchedule();
    }
}
